import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SiteLayoutComponent} from './layout/site-layout/site-layout.component';
import {HomeComponent} from './components/home/home.component';
import {AboutComponent} from './components/static/about/about.component';
import {ContactUsComponent} from './components/static/contact-us/contact-us.component';
import {LoginLayoutComponent} from '../admin/components/login/login-layout/login-layout.component';
import {LoginComponent} from '../admin/components/login/login.component';
import {CategoriesComponent} from './components/categories/categories.component';
import {ProductDetailsComponent} from './components/products/product-details/product-details.component';
import {RegistrationComponent} from './components/user/registration/registration.component';
import {CheckoutWizardComponent} from './components/checkout/checkout-wizard/checkout-wizard.component';
import {CustomerOrdersComponent} from './components/orders/customer-orders/customer-orders.component';
import {WishlistComponent} from './components/wishlist/wishlist.component';
import {PasswordResetComponent} from './components/user/password-reset/password-reset.component';
import {CustomerLoginComponent} from './components/user/customer-login/customer-login.component';
import {ProductBrowserComponent} from './components/product-browser/product-browser.component';
import {CustomerProfileComponent} from './components/customer-profile/customer-profile.component';
import {CustomerRegistrationComponent} from './components/user/customer-registration/customer-registration.component';
import {ProductTourDetailsComponent} from './components/products/product-tour-details/product-tour-details.component';
import {TourLayoutComponent} from './layout/tour-layout/tour-layout.component';
import {PDetailsComponent} from './components/p-details/p-details.component';
import {PaymentKnetComponent} from './components/checkout/payment-methods/knet/payment-knet.component';
import {BankTransferComponent} from './components/checkout/payment-methods/bank-transfer/bank-transfer.component';
import {SearchComponent} from './components/search/search.component';
import {OrderDetailsComponent} from './components/orders/order-details/order-details.component';
import {GuardService} from '../../services/guard.service';
import {VpanelComponent} from './components/360/vpanel/vpanel.component';
import {PlainLayoutComponent} from "./layout/plain-layout/plain-layout.component";
import {ProductDetailsQrComponent} from "./components/products/product-details-qr/product-details-qr.component";
import {
    PaymentMastercardComponent
} from "./components/checkout/payment-methods/mastercard/payment-mastercard.component";
import {
    MastercardPaymentResultComponent
} from "./components/checkout/payment-methods/mastercard/mastercard-payment-result/mastercard-payment-result.component";
import {
    MastercardPaymentCancelComponent
} from "./components/checkout/payment-methods/mastercard/mastercard-payment-cancel/mastercard-payment-cancel.component";
import {
    KnetOrderSuccessComponent
} from "./components/checkout/payment-methods/knet/knet-order-success/knet-order-success.component";
import {
    KnetOrderFailedComponent
} from "./components/checkout/payment-methods/knet/knet-order-failed/knet-order-failed.component";
import {ConfirmCodeComponent} from './components/discound-code/confirm-code/confirm-code.component';
import {
    CampaignSubscriptionConfirmedComponent
} from './components/marketing-popup/campaign-subscription-confirmed/campaign-subscription-confirmed.component';
import {StoresComponent} from "./components/stores/stores.component";
import {BrandsComponent} from "./components/brands/brands.component";
import {PaymentResultComponent} from "./components/knet/payment-result/payment-result.component";


const routes: Routes = [

    {
        path: '',
        component: SiteLayoutComponent,
        children: [
            {path: '', redirectTo: '/web/home', pathMatch: 'full'},

            {path: 'marketing/camp/conf/:hash', component: CampaignSubscriptionConfirmedComponent},
            {path: 'web/home', component: HomeComponent},
            {path: 'web/brands', component: BrandsComponent},
            {path: 'web/stores', component: StoresComponent},
            {path: 'discount/code/:code', component: ConfirmCodeComponent},
            {path: 'web/home/categories/:id', component: CategoriesComponent},
            {path: 'p/details/:id', component: PDetailsComponent},
            {path: 'web/home/product/browser/:id', component: ProductBrowserComponent},
            {path: 'product/details/:sku', component: ProductDetailsComponent},
            {path: 'product/details/byk/:urlKey/:sku', component: ProductDetailsComponent},
            {path: 'search/:value', component: SearchComponent},
            {path: 'customer/orders', component: CustomerOrdersComponent, canActivate: [GuardService]},
            {path: 'order/details/:id', component: OrderDetailsComponent},
            {path: 'customer/profile', component: CustomerProfileComponent, canActivate: [GuardService]},
            {path: 'customer/registration', component: CustomerRegistrationComponent},
            {path: '/user/password/reset', component: PasswordResetComponent},
            {path: 'customer/wishlist', component: WishlistComponent, canActivate: [GuardService]},
            {path: 'user/password/reset', component: PasswordResetComponent},
            {path: 'user/signup', component: CustomerRegistrationComponent},
            {path: 'user/login', component: CustomerLoginComponent},
            {path: 'web/contact_us', component: ContactUsComponent},
            {path: 'web/about', component: AboutComponent},
            {path: 'web/payment/knet/failure', component: KnetOrderFailedComponent},
            {path: 'web/payment/knet/success', component: KnetOrderSuccessComponent},
            {path: 'web/payment/knet/:orderid', component: PaymentKnetComponent},
            {path: 'web/payment/mc/cancel', component: MastercardPaymentCancelComponent},
            {path: 'web/payment/mc/result', component: MastercardPaymentResultComponent},
            {path: 'web/payment/mc/:orderid', component: PaymentMastercardComponent},

            {path: 'web/payment/banktransfer/:orderid', component: BankTransferComponent},
            {path: 'web/checkout-process', component: CheckoutWizardComponent},
            {path: 'web/knet/payment/payresult', component: PaymentResultComponent},
        ]
    },
    {
        path: '',
        component: TourLayoutComponent,
        children: [
            {path: '', redirectTo: '/web/home', pathMatch: 'full'},
            {path: 'product/360/details/:code/:sku', component: ProductTourDetailsComponent},
            {path: 'panel/360/:code', component: VpanelComponent},
            {path: 'checkout/360', component: CheckoutWizardComponent},
        ]
    }
    , {
        path: '',
        component: PlainLayoutComponent,
        children: [
            {path: 'product/qr/:sku', component: ProductDetailsQrComponent},

        ]
    }


];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class WebRoutingModule {
}
